import { useApi } from './useApi';
import { BaseRequest, BaseHookRequest } from './useApi.types';
import {
  GetPregenrationContractPayload,
  ProduceContractPayload,
  SealtedContract,
} from './useContract.types';

export const useSealedContract: BaseHookRequest<SealtedContract[], null> = params => {
  const [{ getRequest }, state] = useApi<SealtedContract[]>(params);
  const getAllSealedContracts: BaseRequest<null> = () =>
    getRequest<null>('manager/contract/sealed');

  return [getAllSealedContracts, state];
};

export const usePregenerateContract: BaseHookRequest<string, GetPregenrationContractPayload> =
  params => {
    const [{ getRequest }, state] = useApi<string>(params);
    const pregenerateContract: BaseRequest<GetPregenrationContractPayload> = details =>
      getRequest<GetPregenrationContractPayload>(
        `manager/contract/pregenerate/${details?.variables.type}`,
        details?.variables,
      );

    return [pregenerateContract, state];
  };

export const useProduceContract: BaseHookRequest<undefined, ProduceContractPayload> = params => {
  const [{ getRequest }, state] = useApi<undefined>(params);
  const produceContract: BaseRequest<ProduceContractPayload> = details =>
    getRequest<ProduceContractPayload>(
      `manager/contract/sign/${details?.variables.type}/${details?.variables.ipAddress}`,
      details?.variables,
    );

  return [produceContract, state];
};
